import React, { useEffect } from 'react';
import { useGameStore } from './store/game-store.js';
import Home from './components/Home/Home.jsx';
import GameBuilder from './components/GameBuilder/GameBuilder.jsx';
import GameView from './components/Game/GameView.jsx';
import StatsView from './components/Stats/StatsView.jsx';
import ToastContainer from './components/shared/ToastContainer.jsx';
import { decodeGameUrl } from './lib/url-state.js';

export default function App() {
  const currentView = useGameStore(s => s.currentView);
  const setView = useGameStore(s => s.setView);
  const setTargets = useGameStore(s => s.setTargets);
  const setGameMode = useGameStore(s => s.setGameMode);

  // Handle URL params on load
  useEffect(() => {
    const params = decodeGameUrl(window.location.href);
    if (params.targets?.length) {
      const targets = params.targets.map(id => {
        const prefix = id[0];
        const numId = parseInt(id.slice(1), 10);
        return {
          id: numId,
          type: prefix === 'a' ? 'actor' : prefix === 'm' ? 'movie' : 'tv',
          nodeId: id,
        };
      });
      setTargets(targets);
      if (params.mode) setGameMode(params.mode);
      setView('builder');
    }
  }, []);

  return (
    <>
      {currentView === 'home' && <Home />}
      {currentView === 'builder' && <GameBuilder />}
      {currentView === 'game' && <GameView />}
      {currentView === 'stats' && <StatsView />}
      <ToastContainer />
    </>
  );
}
